import {BillingAddress} from '../config/billing-address';
import {Provider} from './provider';


export class TaxProvider extends Provider {
    constructor() {
        super();
    }

    getRate(config: any, billingAddress: BillingAddress): Promise<any> {
        return this.submit(`${config.host}pub/tax-rate/${config.portalId}`, billingAddress);
    }

    getAddressConfig = (config: any): Promise<any> => {
        return this.fetch(`${config.host}pub/address/config`);
    }

}
